"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalculateRetirementIncomeGapMobile = CalculateRetirementIncomeGapMobile;
exports.CalculateWillHaveMobile = CalculateWillHaveMobile;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function CalculateWillHaveMobile(_ref) {
  var {
    willHaveValue,
    willNeedValue
  } = _ref;
  var percentage = willHaveValue / willNeedValue * 100;
  var greyShadowPercentage = '';
  if (percentage >= 100) {
    greyShadowPercentage = 'will-have-bar-color mobile-bar-100percent';
  } else if (percentage >= 60 && percentage < 100) {
    greyShadowPercentage = 'will-have-bar-color mobile-bar-75percent';
  } else if (percentage >= 40 && percentage < 60) {
    greyShadowPercentage = 'will-have-bar-color mobile-bar-50percent';
  } else if (percentage < 40 && percentage > 0) {
    greyShadowPercentage = 'will-have-bar-color mobile-bar-25percent';
  } else if (percentage === 0) {
    greyShadowPercentage = 'mobile-bar-fill-container-height';
  }
  var greyBar = /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-bar-fill-container-height ".concat(greyShadowPercentage)
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, greyShadowPercentage ? greyBar : '');
}
function CalculateRetirementIncomeGapMobile(_ref2) {
  var {
    willNeedValue,
    willHaveValue
  } = _ref2;
  var percentage = willHaveValue / willNeedValue * 100;
  var greyShadowPercentage = '';
  if (willHaveValue > willNeedValue) {
    greyShadowPercentage = 'mobile-bar-fill-container-height mobile-bar-100percent';
  } else if (percentage >= 100) {
    greyShadowPercentage = 'retire-income-gap-bar-color mobile-bar-100percent';
  } else if (percentage >= 60 && percentage <= 100) {
    greyShadowPercentage = 'retire-income-gap-bar-color mobile-bar-25percent';
  } else if (percentage >= 40 && percentage < 60) {
    greyShadowPercentage = 'retire-income-gap-bar-color mobile-bar-50percent';
  } else if (percentage < 40 && percentage > 0) {
    greyShadowPercentage = 'retire-income-gap-bar-color mobile-bar-75percent';
  } else if (percentage === 0) {
    greyShadowPercentage = 'retire-income-gap-bar-color mobile-bar-100percent';
  }
  var greyBar = /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-bar-fill-container-height inverted-retire-income-gap ".concat(greyShadowPercentage)
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, greyShadowPercentage ? greyBar : '');
}